import { isMobile } from '@/lib/device'
// const devicePath = !isMobile ? 'pc' : 'mobile'
export default [
  {
    path: 'cost/maintain',
    name: 'CostMaintain',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/costMaintain/Index`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/costMaintain/Index`)
  },
  {
    path: 'cost/detail',
    name: 'CostDetail',
    component: () => import(/* webpackChunkName: "mb-base" */ `@/mobile/costMaintain/Detail`)
  },
  {
    path: 'cost/maintain/detail',
    name: 'CostMaintainDetail',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/costMaintain/Detail`)
  },
  {
    path: 'cost/send',
    name: 'CostSend',
    component: () => import(/* webpackChunkName: "mb-base" */ `@/mobile/costMaintain/CostSend`),
    children: [
      {
        path: 'main',
        name: 'CostSelectMain',
        component: () => import(/* webpackChunkName: "mb-base" */ `@/mobile/costMaintain/CostSendMain`)
      }
      // {
      //   path: 'select',
      //   name: 'CostSendSelect',
      //   component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/costMaintain/CostSendSelect`)
      // }
    ]
  }
  // {
  //   path: 'cost/members',
  //   name: 'CostMembers',
  //   component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/costMaintain/CostMembers`)
  // },
  // {
  //   path: 'cost/range',
  //   name: 'CostRange',
  //   component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/costMaintain/CostRange`)
  // }
]
